import React from "react";
import shiyongzu from "./shiyongzu.jpg";

class TrialLease extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {};
  }

  render() {
    return (
      <div
        className="noSorrowBox"
        style={{ minHeight: "100vh", background: "#f3f4f5" }}
      >
        <img src={shiyongzu} style={{ width: "100%" }} />
      </div>
    );
  }
}
export default TrialLease;



// WEBPACK FOOTER //
// ./src/trialLease/index/index.js